// 数字资产
export default [
    {
        path: '/digital-asset',
        redirect: '/digital-asset/product',
    },

    // 属性
    {
        path: '/digital-asset/attr',
        name: 'digital-attr',
        component: () => import('@/views/digital-asset/attr/Index.vue'),
        meta: {title: '资产属性'},
    },
    {
        path: '/digital-asset/attr/add',
        name: 'digital-attr-add',
        component: () => import('@/views/digital-asset/attr/add/Add.vue'),
        meta: {title: '资产属性'},
    },
    {
        path: '/digital-asset/attr/edit/:code',
        name: 'digital-attr-edit',
        component: () => import('@/views/digital-asset/attr/edit/Edit.vue'),
        meta: {title: '资产属性'},
    },
    {
        path: '/digital-asset/attr/detail/:code',
        name: 'digital-attr-detail',
        component: () => import('@/views/digital-asset/attr/detail/Detail.vue'),
        meta: {title: '资产属性'},
    },
    {
        path: '/digital-asset/attr/log/:code',
        name: 'digital-attr-log',
        component: () => import('@/views/digital-asset/attr/logs/Logs.vue'),
        meta: {title: '资产属性'},
    },

    // 类目
    {
        path: '/digital-asset/def',
        name: 'digital-def',
        component: () => import('@/views/digital-asset/defs/Index.vue'),
        meta: {title: '资产类目'},
    },
    {
        path: '/digital-asset/def/add',
        name: 'digital-def-add',
        component: () => import('@/views/digital-asset/defs/add/Add.vue'),
        meta: {title: '资产类目'},
    },
    {
        path: '/digital-asset/def/edit/:code',
        name: 'digital-def-edit',
        component: () => import('@/views/digital-asset/defs/edit/Edit.vue'),
        meta: {title: '资产类目'},
    },
    {
        path: '/digital-asset/def/detail/:code',
        name: 'digital-def-detail',
        component: () => import('@/views/digital-asset/defs/detail/Detail.vue'),
        meta: {title: '资产类目'},
    },
    {
        path: '/digital-asset/def/log/:code',
        name: 'digital-def-log',
        component: () => import('@/views/digital-asset/defs/logs/Logs.vue'),
        meta: {title: '资产类目'},
    },
    // 资产管理
    {
        path: '/digital-asset/product',
        name: 'digital-asset',
        component: () => import('@/views/digital-asset/asset/Index.vue'),
        meta: {title: '资产管理'},
    },
    {
        path: '/digital-asset/product/add',
        name: 'digital-asset-add',
        component: () => import('@/views/digital-asset/asset/add/Add.vue'),
        meta: {title: '资产管理'},
    },
    {
        path: '/digital-asset/product/edit/:code',
        name: 'digital-asset-edit',
        component: () => import('@/views/digital-asset/asset/edit/Edit.vue'),
        meta: {title: '资产管理'},
    },
    {
        path: '/digital-asset/product/detail/:code',
        name: 'digital-asset-detail',
        component: () => import('@/views/digital-asset/asset/detail/Detail.vue'),
        meta: {title: '资产管理'},
    },
    {
        path: '/digital-asset/product/log-by-code/:code',
        name: 'digital-asset-log-by-code',
        component: () => import('@/views/digital-asset/asset/logs/LogByCode.vue'),
        meta: {title: '资产管理'},
    },
    {
        path: '/digital-asset/product/log-by-def/:defId',
        name: 'digital-asset-log-by-def',
        component: () => import('@/views/digital-asset/asset/logs/LogByDef.vue'),
        meta: {title: '资产管理'},
    },
    // 资产检索
    {
        path: '/digital-asset/search',
        name: 'digital-asset-retrieval',
        component: () => import('@/views/digital-asset/retrieval/Index.vue'),
        meta: {title: '资产检索'},
    },
    {
        path: '/digital-asset/search/search',
        name: 'digital-asset-retrieval-search',
        component: () => import('@/views/digital-asset/retrieval/Search.vue'),
        meta: {title: '资产检索'},
    },
    {
        path: '/digital-asset/search/detail/:code',
        name: 'digital-asset-retrieval-detail',
        component: () => import('@/views/digital-asset/retrieval/detail/Detail.vue'),
        meta: {title: '资产检索'},
    },
    {
        path: '/digital-asset/search/export',
        name: 'digital-asset-retrieval-export',
        component: () => import('@/views/digital-asset/retrieval/export/Index.vue'),
        meta: {title: '资产检索'},
    },
];
